import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const redesignedMainPageSlice = createSlice({
  name: 'isRedesignedMainPage',
  reducers: {},
  initialState,
});

export const isRedesignedMainPageReducer = redesignedMainPageSlice.reducer;
